<a [attr.href]="totype === 'card' ? to ? to : null : null" [target]="template === 'external' ? '_blank' : '_self'">
  <div class="card-product -title" [ngClass]="totype === 'card' ? '' : '-header-link'">
    <div class="-subtitle -fontDisplayThin">{{subtitle}}</div>
    <app-link [to]="to" *ngIf="totype === 'title'"><h3>{{title}}</h3></app-link>
    <h3 *ngIf="totype === 'card'">{{title}}</h3>
  </div>
  <ng-content></ng-content>
</a>